// Parshva S - 16/08/2023 BT-102679 - Breeze- Multi Leg order entry - start
import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BzModal, BzModalHeader, BzModalBody, BzTabs, BzTab } from '../../../components';
import { handleModal } from '../../../redux/actions/modals';
import { MULTI_LEG, OPTION_CHAIN, WATCHLIST_GRID_INDEX, SCRIP_INSTRUMENTS, MULTILEG_DATA_OPTION_INDEX, EXCHANGE_NAME_API } from "../../../utils/global_variables";
import { useSelector, useDispatch } from 'react-redux';
import { clearOptionChain, clearOptionChainData, openOptionChain, toggleOptionChainCheckBox, updateLegDataForOptionChain, updateObjMultiLegData } from '../../../redux/actions/optionChain';
import { InlineScripSeach } from '../../Search';
import Future from './Future';
import { getScripbyTokenAndMktSegId } from '../../../apis';
import { getApiExchangeNameFromMktSegId } from '../../../utils/global_functions';
import moment from 'moment';
import { toastConfig } from '../../../redux/actions/toast';
import OptionChainGrid from '../../OptionChain/OptionChainGrid';
import { sendTouchlineRequest } from '../../../apis/web_socket';
import { updateMultiScripaddLEgModalTabKeyAction } from '../../../redux/actions/orders';

const AddLegMultiscriptModal = ({ legData, setThirdLegData, updateLegData = () => { }, arrRowSelection }) => {
    const dispatch = useDispatch();
    // Ajitesh: Uses different state variable that has updated data in case user changes scrip using search functionality; to show symbol and instrument
    const objScripsRequested = useSelector(state => state?.optionChain?.objScripsRequested);
    const multiLegData = useSelector(state => state.orders?.multiLegData);
    const modals = useSelector(state => state?.modals?.modals);
    const objMultiLegData = useSelector(state => state?.optionChain?.objMultiLegData);
    const arrLegDataForOptionChain = useSelector(state => state?.optionChain?.arrLegDataForOptionChain);
    const multiScripActiveTab = useSelector(state => state?.orders?.multiScripActiveTab);

    const [selectedLegsDataForTabs, setSelectedLegsDataForTabs] = useState([]); // AJitesh 21-07-2024 This will be state to store the temporary options/legs selected by user to be used for checks in Futres and Options tabs
    const [updateClickCount, setUpdateClickCount] = useState(0); // Ajitesh 24=07-2024 state counter variable to only allowe invocation of update function once in case of multiple clicks
    // AJitesh 31-07-2024 State variable to track if futures contracts button should be enabled/disabled
    const [areFutureContractsDisabled, setAreFutureContractsDisabled] = useState(false);
    const inlineSearchRef = useRef();
    /*
    Below function unsubscribes visibleROws of optionChain rows before closing model
    */
    const unsubScribOptionChainData = useCallback(() => {
        if (Object?.keys(objScripsRequested)?.length > 0) {
            let arrDataToUnsubScribe = Object?.keys(objScripsRequested)?.map((eachToken) => {
                return { exchangeId: Number(eachToken?.split("_")[0]), token: Number(eachToken?.split("_")[1]), isSubscribe: false };
            });
            sendTouchlineRequest(arrDataToUnsubScribe);
        }

    }, [objScripsRequested]);

    const handleCloseAddLegModal = useCallback(() => {
        unsubScribOptionChainData();
        dispatch(updateLegDataForOptionChain());
        dispatch(clearOptionChain());
        dispatch(updateObjMultiLegData({}));
        dispatch(toggleOptionChainCheckBox(false));
        dispatch(handleModal([{ "ADD_LEG_MODAL": false }]));
        dispatch(updateMultiScripaddLEgModalTabKeyAction("futures")); // Ajitesh 10-07-2024 Set tab back to futures on add leg modal close
        setSelectedLegsDataForTabs(arrRowSelection);
    }, [arrRowSelection, unsubScribOptionChainData, dispatch]);

    const handleLegData = useCallback((data, isOptionChain = false) => {
        if (isOptionChain) {
            // Ajitesh 24-06-2024 calls set handler with true in case user adds option contract as 3rd leg; false otherwise
            setThirdLegData({ ...data, source: 'legAdd' }, isOptionChain);
        }
        // Ajitesh 03/07/2024 - If segment is only equity add it normally as 3rd leg else add if as 3rd leg via search in below else condition
        else if (legData?.data?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.NSE_DERV_API || legData?.data?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.BSE_DERV_API) {
            if (legData?.legNumber !== null) {
                updateLegData({ ...data, source: 'legUpdate' });
            } else {
                setThirdLegData({ ...data, source: 'legAdd' }, false);
            }
        } else {
            if (legData?.legNumber !== null) {
                // Ajitesh 24-07-2024 Condition to check if scrip being selected for update is same as scrip being updated in multileg then show toast message
                if (multiLegData.find(elem => elem?.extraInfo?.[WATCHLIST_GRID_INDEX.TOKEN] === data?.[WATCHLIST_GRID_INDEX.TOKEN]) !== undefined) {
                    dispatch(toastConfig({ autoDismiss: true, timer: 5000, show: true, message: MULTI_LEG.DUPLICATE_SCRIP_UPDATE }));
                }
                else {
                    // Ajitesh 24-07-2024 Only allow update function to be called onece in case of multiple clicks
                    if (updateClickCount < 1) {
                        updateLegData({ ...data, source: 'legSearchUpdate' });
                        setUpdateClickCount(count => count + 1);
                        return;
                    }
                }
            } else {
                if (multiLegData.find(elem => elem?.extraInfo?.[WATCHLIST_GRID_INDEX.TOKEN] === data?.[WATCHLIST_GRID_INDEX.TOKEN]) !== undefined) {
                    dispatch(toastConfig({ autoDismiss: true, timer: 5000, show: true, message: MULTI_LEG.DUPLICATE_SCRIP_UPDATE }));
                }
                else {
                    setThirdLegData({ ...data, source: 'legSearchAdd' }, false);
                }
            }
        }
    }, [dispatch, legData, multiLegData, setThirdLegData, updateClickCount, updateLegData]);

    /* BT-109096 -- Shuaib.P emptying redux state related option chain --start */
    useEffect(() => {
        return () => {
            dispatch(clearOptionChainData());
        };
    }, [dispatch]);
    /* BT-109096 -- Shuaib.P emptying redux state related option chain --end */

    // Ajitesh 24-07-2024 anytime leg data changes reset counter to 0 as this component only unmounts when mutlileg parent comp unmounts
    useEffect(() => {
        setUpdateClickCount(0);
    }, [arrRowSelection]); // Ajitesh 18-09-2024 Changes deps array to correct property

    // AJitesh 21-07 Effect to set local state variable to value of leg information passed from MultiLeg parent
    useEffect(() => {
        if (arrRowSelection.length) {
            setSelectedLegsDataForTabs(arrRowSelection);
            // Ajitesh 31-07-2024 WHen in edit/search mode we need to enable all possible options
            if (legData?.legNumber) {
                setAreFutureContractsDisabled(false);
            }
        }
    }, [arrRowSelection]);

    useEffect(() => {
        if (Object?.keys(objMultiLegData)?.length >= 3) {
            setAreFutureContractsDisabled(true);
        } else {
            setAreFutureContractsDisabled(false);
        }
    }, [objMultiLegData]);


    // Ajitesh 09-07-2024 Fn to call api for option chain data when options tab is active
    const getOptionsDataForOptionChain = useCallback(async () => {
        if (arrRowSelection?.length > 0) {
            if (arrLegDataForOptionChain?.length === 0) {
                let objForFutScrips = {};
                let arrDataOfMultilegForOptionChain = arrRowSelection?.map((eachLeg) => {
                    if (eachLeg?.instrument?.includes(SCRIP_INSTRUMENTS.FUT)) {
                        let arrOptionChainIndexValues = Object.values(MULTILEG_DATA_OPTION_INDEX).sort((a, b) => a - b);
                        let arrOptionChainIndex = new Array(arrOptionChainIndexValues[arrOptionChainIndexValues.length - 1] + 1).fill('');
                        arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.LEG_NUMBER] = eachLeg?.legNumber;
                        arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.NEXPIRY_DATE] = eachLeg?.expiryDate ?? eachLeg?.extraInfo[WATCHLIST_GRID_INDEX.EXPIRYDATE];
                        arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.STRIKE_PRICE] = eachLeg?.strikeprice;
                        arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.SCRIP_TYPE] = SCRIP_INSTRUMENTS.FUT;
                        arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.SEGMENT_ID] = eachLeg.extraInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID];
                        arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.TOKEN] = eachLeg.extraInfo[WATCHLIST_GRID_INDEX.TOKEN];
                        // objForFutScrips[eachLeg.extraInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] + '_' + eachLeg.extraInfo[WATCHLIST_GRID_INDEX.TOKEN] + '_' + type] = arrOptionChainIndex;
                        return arrOptionChainIndex;

                    } else {
                        let arrOptionChainIndexValues = Object.values(MULTILEG_DATA_OPTION_INDEX).sort((a, b) => a - b);
                        var arrOptionChainIndex = new Array(arrOptionChainIndexValues[arrOptionChainIndexValues.length - 1] + 1).fill('');
                        // if (eachLeg.optiontype === 'CE') {
                        //     arrOptionChainIndex[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN] = eachLeg.extraInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] + '_' + eachLeg.extraInfo[WATCHLIST_GRID_INDEX.TOKEN] + '_' + type;
                        // } else if (eachLeg.optiontype === 'PE') {
                        //     arrOptionChainIndex[OPTION_CHAIN_GRID_INDEX.PUT_SEGMENT_ID_TOKE] = eachLeg.extraInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] + '_' + eachLeg.extraInfo[WATCHLIST_GRID_INDEX.TOKEN] + '_' + type;
                        // } else { }
                        arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.LEG_NUMBER] = eachLeg?.legNumber;
                        arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.NEXPIRY_DATE] = eachLeg?.expiryDate;
                        arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.STRIKE_PRICE] = eachLeg?.strikeprice;
                        arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.SCRIP_TYPE] = eachLeg.optiontype;
                        arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.SEGMENT_ID] = eachLeg.extraInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID];
                        arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.TOKEN] = eachLeg.extraInfo[WATCHLIST_GRID_INDEX.TOKEN];
                        return arrOptionChainIndex;
                        // obj[eachLeg.extraInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] + '_' + eachLeg.extraInfo[WATCHLIST_GRID_INDEX.TOKEN] + '_' + type] = arrOptionChainIndex;
                    }

                });
                // console?.log('arrDataOfMultilegForOptionChain', arrDataOfMultilegForOptionChain);
                // new actions wihich updates new Variable and if its length is not !==0
                dispatch(updateLegDataForOptionChain([...arrDataOfMultilegForOptionChain]));
                if (Object?.keys(objForFutScrips)?.length > 0) {
                    //This dispatch is only for fut scrips asy they are not needed in grid to do applytransaction while removing or unchecking
                    // only for in toaster
                    dispatch(updateObjMultiLegData({ ...objForFutScrips }));
                }

            }
        } else { }
        let newInfo = await getScripbyTokenAndMktSegId([{ mkt: getApiExchangeNameFromMktSegId(legData?.data?.[WATCHLIST_GRID_INDEX?.SEGMENT_ID]), token: legData?.data?.[WATCHLIST_GRID_INDEX.TOKEN] }]);
        dispatch(openOptionChain({
            mappedId: legData?.data?.[WATCHLIST_GRID_INDEX?.SEGMENT_ID],
            expiryDate: moment(legData?.data?.[WATCHLIST_GRID_INDEX.EXPIRYDATE]).format('DDMMMYYYY').toUpperCase(),
            instrumentName: legData?.data?.[WATCHLIST_GRID_INDEX.INSTRUMENT],
            symbol: legData?.data?.[WATCHLIST_GRID_INDEX.SYMBOL],
            instrument: legData?.data?.[WATCHLIST_GRID_INDEX.INSTRUMENT],
            id: legData?.data?.[WATCHLIST_GRID_INDEX?.SEGMENT_ID],
            token: newInfo?.data?.result[0]?.nAssetToken === 0 ? legData?.data?.[WATCHLIST_GRID_INDEX.TOKEN] : newInfo?.data?.result[0]?.nAssetToken,
            assetToken: newInfo?.data?.result[0]?.nAssetToken === 0 ? legData?.data?.[WATCHLIST_GRID_INDEX.TOKEN] : newInfo?.data?.result[0]?.nAssetToken,
            bestFive: false, location: OPTION_CHAIN.MULTI_LEG
        }));
    }, [dispatch, legData?.data, arrRowSelection, arrLegDataForOptionChain]);

    // Ajitesh 09-07-2024 Fn to set active tab
    const setActiveTab = (tabKey) => {
        dispatch(updateMultiScripaddLEgModalTabKeyAction(tabKey));
        if (tabKey === "options") {
            getOptionsDataForOptionChain();
        }
    };

    return (
        <>
            <BzModal show={modals['ADD_LEG_MODAL']} size={legData?.data?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.NSE_DERV_API || legData?.data?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.BSE_DERV_API ? "xl" : "md"} onHide={handleCloseAddLegModal}>
                <BzModalHeader className='p-3'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={7} className='d-flex align-items-center'>
                                {/**Adds symbol and instrument correctly */}
                                <div className='font-medium font-size4 color-text text-uppercase me-2'>{legData?.data?.[WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                                <div className='font-medium font-size4 color-subtext'>{legData?.data?.[WATCHLIST_GRID_INDEX.INSTRUMENT]}</div>
                            </Col>
                            <Col md={4} className='d-flex justify-content-end align-items-center'>
                                {/* <div className='font-medium font-size4 color-text me-2'>{orderInfo?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] || "0.00"}</div>
                                <div className={`font-medium font-size4 color-text ${parseFloat(orderInfo?.[WATCHLIST_GRID_INDEX.LTP_PERCENT]) >= 0 ? 'color-positive' : 'color-negative'}`}> {orderInfo?.[WATCHLIST_GRID_INDEX.LTP_PERCENT] || "0.00"}% ({orderInfo?.[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] || "0.00"})</div> */}
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-items-center'>
                                <div className='icon-16 icon-close icon-dark' onClick={handleCloseAddLegModal}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        {legData?.data?.length && (legData?.data?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.NSE_DERV_API || legData?.data?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.BSE_DERV_API) ?
                            <Row className='g-0 bdr-btm'>
                                <Col>
                                    <div className='d-flex align-items-center'>
                                        <BzTabs className='nav nav-tabs'>
                                            <BzTab className='nav-link text-uppercase' isActive tabKey='futures' onClick={() => setActiveTab("futures")}>Futures</BzTab>
                                            <BzTab className='nav-link text-uppercase' tabKey='options' onClick={() => setActiveTab("options")}>Options</BzTab>
                                        </BzTabs>
                                    </div>
                                </Col>
                            </Row>
                            : null}
                        <Row className='g-0'>
                            <Col>
                                {legData?.data?.length && (legData?.data?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.NSE_DERV_API || legData?.data?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.BSE_DERV_API) ?
                                    <div>
                                        {
                                            multiScripActiveTab === "futures" ?
                                                <Future legNumber={legData?.legNumber} setThirdLegData={(data, type) => { handleLegData({ ...data, legNumber: legData?.legNumber, type }); }} areFutureContractsDisabled={areFutureContractsDisabled} />
                                                : null
                                        }
                                        {
                                            multiScripActiveTab === "options" ?
                                                <OptionChainGrid />
                                                : null
                                        }
                                    </div>
                                    : <InlineScripSeach ref={inlineSearchRef} handleSelectScripFromGlobalSearch={(data) => { handleLegData({ ...data, legNumber: legData?.legNumber }); }} bOpt={legData?.data?.[WATCHLIST_GRID_INDEX?.INSTRUMENT]?.startsWith("OPT")} bFut={legData?.data?.[WATCHLIST_GRID_INDEX?.INSTRUMENT]?.startsWith("FUT")} pageFrom={"multileg"} legDataFromMultilegPage={legData.data} />}
                            </Col>
                        </Row>
                    </Container>
                </BzModalBody>
            </BzModal>


        </>
    );
};

export default memo(AddLegMultiscriptModal);
// Parshva S - 16/08/2023 BT-102679 - Breeze- Multi Leg order entry - end
